const rutasContratos = {
  path: "contratos",
  name: 'contratos',
  redirect: {
    name: 'contratos-index'
  },
  component: () =>
    import(
      /* webpackChunkName: 'Dashboard-Contratos-Root' */ "@/modules/dashboard/pages/contratos/"
    ),
  children: [
    {
      path: "",
      name: "contratos-index",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Contratos-Index' */ "@/modules/dashboard/pages/contratos/ContratosPage"
        ),
    },
    {
      path: "domiciliacion",
      name: "contrato-domiciliacion",
      component: () =>
        import(
          /* webPackChunkName: 'Dashboard-Contratos-Domiciliacion' */ "@/modules/dashboard/pages/contratos/DomiciliacionPage"
        ),
    },
    {
      path: 'domiciliacion/crear',
      name: 'crear-contrato-domiciliacion',
      component: import(
        /* webpackChunkName: 'Dashboard-Contratos-Domiciliacion-Crear' */ "@/modules/dashboard/pages/contratos/domiciliacion/CrearContratoDomiciliacion"
      )
    },
    {
      path: 'compra-venta',
      name: 'contrato-compra-venta',
      component: () => import(
        /* webpackChunkName: 'Dashboard-Contrato-Compra-Venta' */ "@/modules/dashboard/pages/contratos/CompraVentaPage"
      )
    },
    {
      path: 'compra-venta/crear',
      name: 'crear-contrato-compra-venta',
      component: () => import(
        /* webpackChunkName: 'Dashboard-Contrato-Compra-Venta-Crear' */ "@/modules/dashboard/pages/contratos/compra-venta/CrearContratoCompraVenta"
      )
    },
    {
      path: 'general',
      name: 'contrato-general',
      component: () => import(
        /* webpackChunkName: 'Dashboard-Contrato-General' */ "@/modules/dashboard/pages/contratos/general/ContratoGeneral"
      )
    },
    {
      path: 'general/crear',
      name: 'crear-contrato-general',
      component: () => import(
        /* webpackChunkName: 'Dashboard-Contrato-General' */ "@/modules/dashboard/pages/contratos/general/CrearContratoGeneral"
      )
    }
  ],
};

export default rutasContratos;
